<template>
<!--  <router-view v-slot="{ Component, route}">-->
<!--    <transition :name="route.meta.transitionName">-->
<!--      <keep-alive>-->
<!--        <component :is="Component" />-->
<!--      </keep-alive>-->
<!--    </transition>-->
<!--  </router-view>-->
  <router-view/>
</template>

<script>
  import '@/assets/css/m.css';
  import {defineComponent} from "vue";
  export default defineComponent({
  });
</script>

<style>
  .slide-left-enter, .slide-right-leave-active {
    opacity: 0;
    -webkit-transform: translate(300px, 0);
    transform: translate(300px, 0);
    transition: all .5s cubic-bezier(.55,0,.1,1);
  }

  .slide-left-leave-active, .slide-right-enter {
    opacity: 0;
    -webkit-transform: translate(-300px, 0);
    transform: translate(-300px, 0);
    transition: all .5s cubic-bezier(.55,0,.1,1);
  }
</style>